<script lang="ts" setup>
import { Ref } from 'vue'
const wizard = useWizard()
const { data, sendEvent } = useTracker()

const { $t } = useNuxtApp()

const closeButton = inject<Ref<HTMLButtonElement>>('modalCloseButton')
const backButton = ref<HTMLButtonElement>()

const goBack = $t('Späť')

const handleGoBack = (autofocus: boolean): void => {
    wizard.setBackButtonFocusState(false)
    wizard.goBack(autofocus)
    sendEvent({
        data: {
            ...data,
            click: goBack,
        },
    })
}

const handleTabClick = (e: KeyboardEvent): void => {
    wizard.setBackButtonFocusState(false)

    const { shiftKey } = e
    if (shiftKey) {
        wizard.resetCurrentIndex()
        closeButton?.value.focus()
        return
    }

    wizard.focusFirstItem()
    return
}

watch(
    (): boolean => wizard.data.value.backButtonFocused,
    (newVal: boolean): void => {
        if (newVal) {
            setTimeout((): void => backButton.value?.focus(), 0)
            return
        }
        backButton.value?.blur()
    }
)
</script>

<template>
  <button
    ref="backButton"
    :class="{ 'd-none': wizard.data.value.previous.length <= 0 }"
    type="button"
    color="link"
    class="back-button fw-bolder d-flex align-items-center position-absolute top-0 start-0 ps-5 pt-4 bg-transparent border-0"
    @click.prevent="handleGoBack(false)"
    @keydown.enter.prevent="handleGoBack(true)"
    @keydown.tab.prevent="handleTabClick"
  >
    <svg
      class="d-block text-secondary me-3"
      width="6"
      height="12"
      aria-hidden="true"
    >
      <use xlink:href="#angle-left" />
    </svg>
    {{ goBack }}
  </button>
</template>
